import WorkOrderIcon from '@atom/components/common/svgIcons/work';
import WorkOrderStatusPill from '@atom/components/common/workOrderDetail/workOrderStatusPill/WorkOrderStatusPill';
import { MapWorkOrder } from '@atom/types/map';
import timeUtilities from '@atom/utilities/timeUtilities';

import classes from './drawerContent.module.css';

interface Props {
  workOrder: MapWorkOrder;
}

const WorkOrderListItem = ({ workOrder }: Props) => {
  const { name, statusId, dueDate, assigneeCount, taskCount } = workOrder;

  return (
    <div className={classes.listItemV2}>
      <div className={classes.iconContainer}>
        <WorkOrderIcon status={+statusId} />
      </div>
      <div className={classes.descriptionContainer}>
        <div className={classes.subheading}>{name}</div>
        <div style={{ margin: '-6px 0 -1px' }}>
          <WorkOrderStatusPill
            statusId={statusId}
            className="dashboard-map-list"
          />
        </div>
        <div className={classes.detailsContainer}>
          <div className={classes.secondary}>
            Due Date: {timeUtilities.setDisplayDate(dueDate)}
          </div>
          <div className={classes.secondary}>Team: {assigneeCount}</div>
          <div className={classes.secondary}>Tasks: {taskCount}</div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderListItem;
